import React from 'react';
import { Link } from 'react-router-dom';

const FAQ: React.FC = () => {
  return (
    <div className="container-fluid faq-section bg-light py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
            <h4 className="text-primary">Some Important FAQ's</h4>
            <h1 className="display-4 mb-4">Frequently Asked Questions</h1>
            <p className="mb-4">Find answers to common questions about our water treatment solutions, 
              services, and capabilities. We're here to help you understand how WTIL can address 
              your specific water treatment challenges.
            </p>
            <Link className="btn btn-primary py-3 px-5" to="/contact">Have Any Questions</Link>
          </div>
          <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.4s">
            <div className="h-100">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      What kind of water treatment projects does WTIL undertake?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show active"
                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      WTIL offers turnkey and tailor made solutions for industrial and municipal clients, covering the complete spectrum—from raw water treatment to wastewater recycling. Our expertise includes UF, RO, DM plants, STPs, ETPs, and ZLD systems.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Can you support revamping or modernization of existing treatment plants?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Yes. We specialize in upgrading legacy water and effluent treatment systems to improve efficiency, compliance, and capacity—without full replacement. This includes automation, capacity enhancement, and energy optimization.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseThree" aria-expanded="false"
                      aria-controls="collapseThree">
                      What chemicals does WTIL supply for water treatment?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse"
                    aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      We supply a complete range of high-performance specialty chemicals for boilers, cooling towers, RO systems, and ETP/STPs. All formulations are backed by in-house technical support and monitoring services.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseFour" aria-expanded="false"
                      aria-controls="collapseFour">
                      Does WTIL provide O&M (Operations & Maintenance) services?
                    </button>
                  </h2>
                  <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Absolutely. Our dedicated O&M division manages over 50 MLD of plant capacity across sectors like cement, textile, automotive, and municipal utilities. We offer manpower, AMC contracts, and complete plant operation support.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseFive" aria-expanded="false"
                      aria-controls="collapseFive">
                      What is a BOO model, and do you offer it?
                    </button>
                  </h2>
                  <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      BOO stands for Build-Own-Operate. Under this model, we set up and run water treatment plants at client sites and charge on a per-KL basis. This eliminates capital expenditure for the client while ensuring consistent water quality.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSix">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseSix" aria-expanded="false"
                      aria-controls="collapseSix">
                      Can WTIL provide customized solutions for complex industrial needs?
                    </button>
                  </h2>
                  <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Yes. Every industry has unique water challenges. We tailor our technology, chemicals, and services based on your process requirements, water quality, discharge norms, and cost constraints.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
